import { FormatConstants } from '../../../common/FormatConstants'
import ApiUrlConstants from '@/common/ApiUrlConstants'
import RestService from '@/common/RestService'
import CACA1130RequestModel from '@/api/data/CAC/CACA1130/CACA1130RequestModel'
import CACA1130ResponseModel from '@/api/data/CAC/CACA1130/CACA1130ResponseModel'
import Moment from 'moment'
import CommonUtil from '@/common/utils/CommonUtil'
export default class CACG1130Service {
  /**
   * CACA1130 API呼出処理
   * @param productNo CACA1130 API呼出処理
   * @param shhnCd
   * @returns CACA1130ResponseModel
   */
  public async callAPICACA1130(
    productNo: string,
    shhnCd: string
  ): Promise<CACA1130ResponseModel> {
    const caca1130RequestModel = new CACA1130RequestModel()
    caca1130RequestModel.productNo = productNo
    caca1130RequestModel.shhnCd = shhnCd

    const caca1130ResponseModel: CACA1130ResponseModel = <
      CACA1130ResponseModel
    > await RestService.post(ApiUrlConstants.CACA1130, caca1130RequestModel)
    return caca1130ResponseModel
  }

  /**
   * チャートのデータを作成する
   * @param cacg1030ViewModel
   * @returns dataReturn
   */
  public createDataChart(creditingRateTenYearLst): Array<any> {
    const dataReturn = creditingRateTenYearLst?.map((item) => {
      return [
        Date.parse(Moment(item.rateYears).format('YYYY/MM/28')),
        CommonUtil.roundNumber(
          item.creditingRate,
          FormatConstants.COMMISSION_TRUST_FEE
        )
      ]
    })

    return dataReturn
  }
}
